import { isString, isObject } from 'lodash'

export default function(messages) {
  const output = {}

  for (const key in messages) {
    if (messages.hasOwnProperty(key)) {
      const value = messages[key]

      if (isString(value)) {
        output[key] = value
      } else if (isObject(value)) {
        normalizeObject(value, output)
      }
    }
  }

  return output
}

function normalizeObject(value, output) {
  for (const subKey in value) {
    if (value.hasOwnProperty(subKey)) {
      output[subKey] = value[subKey]
    }
  }
}
